export const checklist_theme_section = {
  specificationError: 'Verplicht',
};
